import Vue from 'vue'

const FragmentFactory = Vue.FragmentFactory
const remove = Vue.util.remove
const createAnchor = Vue.util.createAnchor

export default {
  terminal: true,
  bind: function () {
    if (this.el.__vue__) {
      return Vue.util.warn(
        `v-inject="${this.expression}"` +
        ' cannot be used on an instance root element.'
      )
    }
    const container = this.arg
      ? document.getElementById(this.arg)
      : document.body
    if (container) {
      this.anchor = createAnchor('v-inject')
      container.appendChild(this.anchor)
      remove(this.el)
      const factory = new FragmentFactory(this.vm, this.el)
      this.frag = factory.create(this._host, this._scope, this._frag)
      this.frag.before(this.anchor)
    }
  },
  unbind: function () {
    this.frag.remove()
    remove(this.anchor)
  }
}



/** WEBPACK FOOTER **
 ** ./src/lib/v-inject.js
 **/